//employee views
import Employees from "@/views/employees/Employees.vue";
import EmployeeDetail from "@/views/employees/EmployeeDetail.vue";
import AddEmployees from "@/views/employees/AddEmployees.vue";
import EmployeesUpload from "@/views/employees/BulkAddEmployees.vue";

import VendorDashboard from "@/views/Dashboard.vue";

import Customers from "@/views/customers/Customers.vue";
import CustomerDetail from "@/views/customers/CustomerDetail.vue";
import Reports from "@/views/Reports.vue";
import OwnerDetails from "@/views/account/OwnerDetails.vue";
import ShowProofOfEmployeeMonitoring from "@/views/ShowProofOfEmployeeMonitoring.vue";
import IncompleteProofOfMonitoringRedirector from "@/views/IncompleteProofOfMonitoringRedirector.vue";
import SubscriptionPayment from "@/views/SubscriptionPayment.vue";
import AddOwner from "@/views/AddOwner.vue";
import ChecklistItem from "@/views/ChecklistItem";
import ProofOfMonitoringSubmission from "@/views/ProofOfMonitoringSubmission.vue";
import VendorSignupLayout from "@/views/vendor/signup/Layout.vue";
import ContentHeader from "@/views/ContentHeader";

import { VENDOR_ROLE } from "@/services/constants";
import ConnectSignupID from "@/views/vendor/signup/ConnectSignupID.vue";
import FdrWrapper from "@/views/fdr/FdrWrapper.vue";

const vendorDashBoardRoute = {
  path: "/dashboard",
  name: "dashboard",
  component: VendorDashboard,
  meta: {
    humanName: "Dashboard",
    navbarMenu: {
      name: "Home",
      order: 1,
      icon: "$dashboard"
    },
    role: VENDOR_ROLE
  }
};

var employeesRoute = {
  path: "/employees", //This path is hardcoded in fdr-vendor-web/src/components/monitoring/AddEmployeeMonitoring.tsx
  name: "employees",
  component: Employees,
  meta: {
    humanName: "Employees",
    navbarMenu: {
      name: "My Employees",
      order: 20,
      icon: "$population"
    },
    role: VENDOR_ROLE
  }
};

var employeeDetailRoute = {
  path: "/employees/:employeeId/detail",
  name: "employeeDetail",
  component: EmployeeDetail,
  props: true,
  meta: {
    humanName: "Employee Detail",
    role: VENDOR_ROLE
  }
};

var showProofOfEmployeeMonitoringRoute = {
  path: "/employee-monitoring-splash",
  name: "showProofOfEmployeeMonitoring",
  component: ShowProofOfEmployeeMonitoring,
  meta: {
    humanName: "Show Proof of Employee Monitoring",
    navbar: false,
    role: VENDOR_ROLE
  },
  props: true
};

var incompleteProofOfMonitoringRedirectorRoute = {
  path: "/incomplete-proof-of-monitoring-redirector",
  name: "incompleteProofOfMonitoringRedirector",
  component: IncompleteProofOfMonitoringRedirector,
  meta: {
    navbar: false,
    role: VENDOR_ROLE
  },
  props: true
};

var subscriptionPaymentRoute = {
  path: "/subscription-payment",
  name: "subscriptionPayment",
  component: SubscriptionPayment,
  props: true,
  meta: {
    humanName: "Subscription Payment",
    navbar: false,
    role: VENDOR_ROLE
  }
};

var addEmployeesRoute = {
  path: "/employees/add",
  name: "addEmployees",
  component: AddEmployees,
  meta: {
    humanName: "Add Employees",
    role: VENDOR_ROLE
  }
};

var employeeUploadRoute = {
  path: "/employees/upload",
  name: "employeesUpload",
  component: EmployeesUpload,
  meta: {
    humanName: "Employees Upload",
    role: VENDOR_ROLE
  }
};

var customersRoute = {
  path: "/customers",
  name: "customers",
  component: Customers,
  meta: {
    humanName: "Customers",
    navbarMenu: {
      name: "My Customers",
      order: 10,
      icon: "$myCustomers"
    },
    role: VENDOR_ROLE
  }
};

var customerDetailRoute = {
  path: "/customers/:customerId/detail",
  name: "customerDetail",
  component: CustomerDetail,
  props: true,
  meta: {
    humanName: "Customer To-Dos",
    role: VENDOR_ROLE
  }
};

var reportsRoute = {
  path: "/reports",
  name: "reports",
  component: Reports,
  meta: {
    humanName: "Reports",
    navbarMenu: {
      name: "Reports",
      order: 30,
      icon: "$reports"
    },
    role: VENDOR_ROLE,
    featureFlaggedOffBy: "FDR_AUDIT_TAB"
  }
};

const auditRoute = {
  path: "/audit",
  name: "audit",
  component: FdrWrapper,
  meta: {
    humanName: "Audit",
    navbarMenu: {
      name: "Audit",
      order: 30,
      icon: "$fileLines",
      iconStyles: "opacity: 50%; width: 14px"
    },
    role: VENDOR_ROLE,
    featureFlaggedOnBy: "FDR_AUDIT_TAB"
  }
};

var ownerDetailsRoute = {
  path: "/owners/:ownerId/detail",
  name: "ownerDetails",
  component: OwnerDetails,
  props: true,
  meta: {
    humanName: "Owners",
    role: VENDOR_ROLE
  }
};

var addOwnersRoute = {
  path: "/owners/add",
  component: AddOwner,
  props: {
    navigateToOnDismiss: { name: "account", hash: "#owners" }
  },
  meta: {
    humanName: "Add Owner",
    role: VENDOR_ROLE
  },
  children: [
    {
      path: "",
      name: "addOwner",
      component: ContentHeader,
      props: {
        headerIcon: "mdi-account-circle-outline",
        headerTitle: "Account",
        backNavigation: true,
        backNavigationTo: { name: "account", hash: "#owners" },
        backNavigationText: "Owner Overview"
      }
    }
  ]
};

var checklistItemRoute = {
  path: "/customers/:customerId/checklist/:itemId",
  name: "checklistItem",
  component: ChecklistItem,
  props: true,
  meta: {
    humanName: "Checklist Item",
    role: VENDOR_ROLE
  }
};

var proofOfMonitoringSubmissionRoute = {
  path:
    "/proof-of-monitoring-submission/customers/:customerId/checklist/:checklistItemId",
  name: "proofOfMonitoringSubmission",
  component: ProofOfMonitoringSubmission,
  props: true,
  meta: {
    humanName: "Proof of Monitoring",
    role: VENDOR_ROLE
  }
};

var vendorSignupRoute = {
  path: "/vendor-signup/signupCode/:signupCode/:stepName?",
  name: "vendorSignup",
  component: VendorSignupLayout,
  props: true,
  meta: {
    humanName: "Signup",
    navbar: true,
    navbarLogoOnly: true,
    role: VENDOR_ROLE
  }
};

var connectSignupIdRoute = {
  path: "/vendor/connect-signup-id",
  name: "connectSignupId",
  component: ConnectSignupID,
  meta: {
    title: "Vendor Connect SignupID",
    humanName: "Connect Signup ID",
    navbar: false,
    footer: true,
    role: VENDOR_ROLE
  }
};

export const defaultVendorRoute = vendorDashBoardRoute;

export const VendorRoutes = [
  employeesRoute,
  employeeDetailRoute,
  incompleteProofOfMonitoringRedirectorRoute,
  showProofOfEmployeeMonitoringRoute,
  subscriptionPaymentRoute,
  addEmployeesRoute,
  employeeUploadRoute,
  vendorDashBoardRoute,
  customersRoute,
  customerDetailRoute,
  reportsRoute,
  ownerDetailsRoute,
  addOwnersRoute,
  checklistItemRoute,
  proofOfMonitoringSubmissionRoute,
  vendorSignupRoute,
  connectSignupIdRoute,
  auditRoute
];
